import { render, staticRenderFns } from "./ProfilesWidget.vue?vue&type=template&id=0e1f8028&scoped=true&"
import script from "./ProfilesWidget.vue?vue&type=script&lang=js&"
export * from "./ProfilesWidget.vue?vue&type=script&lang=js&"
import style0 from "./ProfilesWidget.vue?vue&type=style&index=0&id=0e1f8028&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1f8028",
  null
  
)

export default component.exports